import store from "@/store"

export default function legalDocumentsEnabled({ next, router }) {
    if(store.state.auth.legalDocumentsEnabled) return next()
    router.push('/calendar').catch(()=>{})
}
